import {HELP_SUPPORT_REWARDS_ENTRY_EMAIL_DEVICE_SWAP} from 'src/pages/scheduleCallback/constants/appContexts';
import {appointmentConfirmationStep} from 'src/pages/scheduleCallback/store/actions/appointmentConfirmationStep';
import {errorStep} from 'src/pages/scheduleCallback/store/actions/errorStep';
import {
  CREATE_INTERACTION_ERROR,
  CREATE_INTERACTION_SUCCESS,
  createInteraction,
} from 'src/pages/scheduleCallback/store/actions/interactions';
import {
  email,
  intent,
  phone,
  timeslot,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {changeView} from 'src/shared/currentView/actions';
import {LOADING} from 'src/shared/currentView/commonViews';
import {waitForNextOneOf} from 'src/shared/events';

export const submitTimeslot = () => async (dispatch, getState) => {
  const appContext = intent(getState()) === 'DEVICE_SWAP_REWARDS' ? HELP_SUPPORT_REWARDS_ENTRY_EMAIL_DEVICE_SWAP : null;

  dispatch(changeView(LOADING));
  dispatch(createInteraction({
    phone: phone(getState()),
    intent: intent(getState()),
    email: email(getState()),
    timeslot: timeslot(getState()),
    ...(appContext && {appContext}),
  }));

  const {type} = await waitForNextOneOf([CREATE_INTERACTION_SUCCESS, CREATE_INTERACTION_ERROR]);

  if (type === CREATE_INTERACTION_ERROR) {
    return dispatch(errorStep());
  }

  dispatch(appointmentConfirmationStep());
};
